import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import footballReducer from 'modules/Football/reducers/reducer';
import horseRacingReducer from 'modules/HorseRacing/reducers/reducer';
import greyhoundRacingReducer from 'modules/GreyhoundRacing/reducers/reducer';
import commonReducer from 'modules/Common/reducers/reducer';
import insiderReducer from 'modules/Insider/reducers/reducer';

import server from './server';

export default combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,
  server,
  football: footballReducer,
  horseRacing: horseRacingReducer,
  greyhoundRacing: greyhoundRacingReducer,
  common: commonReducer,
  insider: insiderReducer
});



// WEBPACK FOOTER //
// ./redux/reducer.js